import {Component, EventEmitter, Input, Output, ViewEncapsulation} from '@angular/core';
import {StateService} from "@uirouter/angular";
import {MatDialog} from "@angular/material";
import {Service} from "../../../../../classes/service";
import {kanServiceDialog} from "../../../dialogs/service-dialog/component";
import {kanContractDialog} from "../../../dialogs/contract-dialog/component";
import {kanServicesService} from "../../../../services/services/services";

@Component({
    selector: 'kan-service-list-item',
    templateUrl: './component.html',
    styleUrls: ['./component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class kanServiceListItem {
    @Input() service: Service;
    @Output() refresh: EventEmitter<any> = new EventEmitter();

    constructor(private stateService: StateService,
                private dialog: MatDialog,
                private servicesService: kanServicesService) {
    }

    ngOnInit(): void {

    }

    public editContract(event) {
        let dialogRef = this.dialog.open(kanContractDialog, {
            data: {
                contract: this.service.contract
            },
            disableClose: true,
            width: '100%',
            maxWidth: '100%',
            height: '100%',
            maxHeight: '100%'
        });

        dialogRef.afterClosed().subscribe((result) => {
            if (result) {
                if(result.action === 'add') {
                    this.service.contractId = result.contract.id;
                    this.servicesService.updateService(this.service)
                        .then(() => {
                            this.refresh.emit();
                        })
                        .catch((error) => {
                            console.log(error);
                        });
                } else {
                    this.refresh.emit();
                }
            }
        });
    }

    public edit(event) {
        let dialogRef = this.dialog.open(kanServiceDialog, {
            data: {
                service: this.service
            },
            disableClose: true,
            width: '100%',
            maxWidth: '100%',
            height: '100%',
            maxHeight: '100%'
        });

        dialogRef.afterClosed().subscribe((result) => {
            if (result === 'update') {
                this.refresh.emit();
            }
        });
    }

    public remove(event) {
        // let dialogRef = this.dialog.open(kanRemoveDialog, {
        //     disableClose: true
        // });
        //
        // dialogRef.afterClosed().subscribe((result) => {
        //     if (result === 'remove') {
        //         this.servicesService.removeService(this.service)
        //             .then((data) => {
        //                 this.refresh.emit();
        //             });
        //     }
        // });
    }
}



// WEBPACK FOOTER //
// ./src/modules/admin/components/service/list-item/component.ts